import type { SmartSchedulingSlotsPayload } from "./smart-scheduling.types";

import { smartSchedulingEndpoint } from "../endpoints";

export async function bookSmartSchedulingAvailability(
  userToken: string,
  payload: SmartSchedulingSlotsPayload,
) {
  const response = await fetch(
    `${smartSchedulingEndpoint}/${userToken}/availability`,
    {
      method: "POST",
      body: JSON.stringify({ ...payload }),
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    return response.json();
  }

  return response.json();
}
